<template>
  <div>
    <headerNotice routerName="分类管理"></headerNotice>
    <!-- 头部操作栏 -->
    
    <div class="handleBar">
       
      <el-button type="danger" @click="delChoosed()">批量删除</el-button>
      <el-button type="primary" @click="addDialog">
        <i class="el-icon-plus"></i> 添加
      </el-button>
       <el-input placeholder="请输入名称" v-model="serachForm.cateName" class="search">
            <el-button slot="append" icon="el-icon-search" @click="serachIt"></el-button>
         </el-input>
    </div>
    <!-- 单位列表 -->
    <div class="unitBox">
      <el-table :data="items" class="tableBox" style="width:100%" fit v-loading="loading" @selection-change="handleSelectionChange">
        <el-table-column align="center" type="selection" width="55"></el-table-column>
        <el-table-column align="center" prop="sort" label="排序"></el-table-column>
        <el-table-column align="center" prop="cateName" label="标签名称"></el-table-column>
        <el-table-column align="center" prop="createTime" label="添加时间"></el-table-column>
        <el-table-column align="center" label="操作">
          <template slot-scope="scope">
            <el-button size="small" type="warning" @click="editBtn(scope.row)">修改</el-button>
            <el-button size="small" type="danger" @click="deleteBtn(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <!--分页-->
      <el-pagination
        class="pagination"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page.sync="currentPage"
        :page-sizes="[10, 20, 30, 40]"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalCount"
      ></el-pagination>
    </div>

    <!-- 新增框 -->
    <el-dialog title="新增分类" :visible.sync="showDialog" width="30%">
      <el-form class="signUp_Form" label-width="125px">
        <el-row>
          <el-col :span="20">
            <el-form-item label="分类名称" :rules="[{'required':true}]">
              <el-input v-model="cateName" maxlength="4" placeholder="请输入分类名称" size="small"></el-input>
            </el-form-item>
            <el-form-item label="排序" :rules="[{'required':true}]">
              <el-input v-model="sort" maxlength="4" placeholder="请输入排序" size="small"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <div class="saveBox">
          <el-button type="primary" class="saveUnitBtn" @click="saveUnit">保存</el-button>
        </div>
      </el-form>
    </el-dialog>
    <!--修改dialog-->
    <el-dialog title="分类修改" :visible.sync="editDialog">
      <el-form :model="editForm" class="signUp_Form" label-position="right" label-width="125px">
        <div>
          <el-row>
            <el-col :sm="12">
              <el-form-item label="分类名称：">
                <el-input
                  class="inputStyle"
                  v-model="editForm.cateName"
                  maxlength="4"
                  placeholder="请输入单位名称，≤4个字"
                  size="small"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :sm="12">
              <el-form-item label="排序：">
                <el-input class="inputStyle" type="number" v-model="editForm.sort" size="small"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
        <div style="text-align:center;">
          <el-button type="primary" @click="editSaveData">保存</el-button>
        </div>
      </el-form>
    </el-dialog>
    <!--dialog end-->
  </div>
</template>

<script>
import headerNotice from "./../../components/common/headerNotice.vue";
export default {
  data() {
    return {
      loading: true,
      totalCount: 0, //总数据条数
      maxResultCount: 10, //默认一页显示的个数,
      currentPage: 1,
      items: [],
      showDialog: false, //增加分类弹框
      cateName: "",
      sort: 1,
      editDialog: false, //关闭分类弹框
      editForm: {},
      choosedItem: [], //已选择的分类列表
       serachForm: {//高级搜索弹框数据
        'cateName': '',
      }
    };
  },
  components: {
    headerNotice
  },
  mounted() {
    let self = this;
    this.getDatas({
      MaxResultCount: this.maxResultCount,
      CateName: "",
      CustomizationType: 2,
    });
  },
  watch: {
    showDialog(val) {
      if (!val) {
        this.newUnitName = "";
      }
    }
  },
  methods: {
    //获取列表数据
    getDatas(params) {
      let self = this;
      $http.GET({
        url:
          this.$store.state.apiUrl +
          "/api/services/app/AdminCustomizationCate/GetPageList",
        params: params,
        success(res) {
          self.items = res.items;
          self.totalCount = res.totalCount;
          self.loading = false;
        },
        fail(res) {
          self.loading = false;
        }
      });
    },
    //添加
    addDialog() {
      this.showDialog = true;
    },
    //保存单位
    saveUnit() {
      if (!this.cateName || this.cateName.length == 0) {
        this.$message({
          message: "分类名称不能为空",
          type: "error"
        });
        return;
      }
      let self = this;
      $http.POST({
        url:
          this.$store.state.apiUrl +
          "/api/services/app/AdminCustomizationCate/Create",
        data: {
          sort: this.sort,
          cateName: this.cateName,
          customizationType: 2
        },
        success(res) {
          self.$message({
            message: "添加成功",
            type: "success"
          });
          self.getDatas({
            MaxResultCount: self.maxResultCount,
             CateName: "",
             CustomizationType: 2,
          });
          self.currentPage = 1;
          self.showDialog = false;
        },
        fail(res) {}
      });
    },
    //修改单位
    editBtn(row) {
      this.editDialog = true;
      this.editForm = row;
    },
    //修改单位 保存按钮
    editSaveData() {
      this.editDialog = false;
      let self = this;
      $http.PUT({
        url:
          this.$store.state.apiUrl + "/api/services/app/AdminCustomizationCate/Update",
        data: this.editForm,
        success(res) {
          self.$message({
            message: "修改成功",
            type: "success"
          });
          self.getDatas({
            MaxResultCount: self.maxResultCount,
             CateName: "",
             CustomizationType: 2,
          });
          self.currentPage = 1;
        },
        fail(res) {}
      });
    },
    //删除单位
    deleteBtn(row) {
      let self = this;
      this.$confirm("此操作将永久删除该条数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
             let itemsIDsArr = [];
           itemsIDsArr.push(row.cateID);
          $http.POST({
            url:
              this.$store.state.apiUrl +
              "/api/services/app/AdminCustomizationCate/Delete",
            data: {
              cateIDs: itemsIDsArr
            },
            success(res) {
              self.$message({
                message: "删除成功",
                type: "success"
              });
              self.getDatas({
                MaxResultCount: self.maxResultCount,
                 CateName: "",
               CustomizationType: 2,
              });
              self.currentPage = 1;
            },
            fail(res) {}
          });
        })
        .catch(() => {});
    },

    //勾选单个表格
    handleSelectionChange(val) {
      this.choosedItem = val;
    },
    //批量删除
    delChoosed() {
      let self = this;
      if (this.choosedItem.length) {
        this.$confirm("确认将所勾选的分类全部删除吗？", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
          .then(() => {
            let itemsIDsArr = [];
            self.choosedItem.forEach((ele, index) => {
              itemsIDsArr.push(ele.cateID);
            });
            console.log(itemsIDsArr);
            $http.POST({
              url:
                self.$store.state.apiUrl +
                "/api/services/app/AdminCustomizationCate/Delete",
              data: {
                cateIDs: itemsIDsArr
              },
              success(res) {
                self.$message({
                  message: "删除成功",
                  type: "success"
                });
               self.getDatas({
                MaxResultCount: self.maxResultCount,
                 CateName: "",
               CustomizationType: 2,
              });
              self.currentPage = 1;
              },
              fail(res) {
                self.loading = false;
              }
            });
          })
          .catch(() => {});
      } else {
        this.$message.error("请先选择商品！");
        return;
      }
    },
    //一页显示多少个
    handleSizeChange(val) {
      this.maxResultCount = val;
      let params = {
        MaxResultCount: val
      };
      this.getDatas(params);
    },
    //跳转到指定页
    handleCurrentChange(val) {
      this.loading = true;
      let skipCount = (val - 1) * this.maxResultCount;
      let params = {
        SkipCount: skipCount,
        MaxResultCount: this.maxResultCount
      };
      this.getDatas(params);
    },
    //搜索
      serachIt() {
            this.getDatas({
                MaxResultCount: self.maxResultCount,
                CateName: this.serachForm.cateName,
                CustomizationType: 2,
            });
            this.currentPage = 1;
        },
  }
};
</script>

<style lang='scss' scoped>
// 头部操作栏
.handleBar {
  margin: 0px 120px;
  margin-top: 20px;
  padding: 20px 30px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
// 单位列表
.unitBox {
  margin: 20px 130px;
  .tableBox {
    border: 1px solid #c5c5c5;
  }
  ul {
    li {
      height: 80px;
      border-bottom: 1px solid #c5c5c5;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding-left: 20px;
    }
  }
}
.saveBox {
  width: 100%;
  display: flex;
  justify-content: center;
}
.handleBar{
    float: left;
}
.search{
    margin-left: 10px;
}
</style>